<div class="container">
    <div class="row justify-content-center">
        <div class="col-5 text-center heading mat-elevation-z8 coolfont"><h1>CREATE NEW PLAN</h1></div>
    </div>
    <div class="row  justify-content-center">
        <div class="col-5 planform mat-elevation-z8">
            <form [formGroup]="exampleForm" novalidate (ngSubmit)="addNewPlan(exampleForm.value)">
                <div class="row">
                    <div class="col col-12">
                        <div class="form-group">
                            <mat-form-field>
                              <input matInput placeholder="Plan Name" class="form-control" formControlName="pname">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.pname">
                              <mat-error *ngIf="exampleForm.get('pname').hasError(validation.type) && (exampleForm.get('pname').dirty || exampleForm.get('pname').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                              <input matInput placeholder="Speed" class="form-control" formControlName="speed">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.speed">
                              <mat-error *ngIf="exampleForm.get('speed').hasError(validation.type) && (exampleForm.get('speed').dirty || exampleForm.get('speed').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                              <input matInput placeholder="Data" class="form-control" formControlName="data">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.data">
                              <mat-error *ngIf="exampleForm.get('data').hasError(validation.type) && (exampleForm.get('data').dirty || exampleForm.get('data').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                              <input matInput placeholder="Exhausted Data Speed" class="form-control" formControlName="exspeed">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.exspeed">
                              <mat-error *ngIf="exampleForm.get('exspeed').hasError(validation.type) && (exampleForm.get('exspeed').dirty || exampleForm.get('exspeed').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                
                        <div class="form-group">
                            <mat-form-field>
                              <input matInput type="number" min="0" max="10000" placeholder="Price" class="form-control" formControlName="price">
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.price">
                              <mat-error *ngIf="exampleForm.get('price').hasError(validation.type) && (exampleForm.get('price').dirty || exampleForm.get('price').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                
                        <div class="form-group">
                            <mat-form-field>
                              <!-- <input matInput type="text" placeholder="Category" class="form-control" formControlName="category"> -->
                              <mat-label>Category</mat-label>
                              <mat-select formControlName="category">
                                <mat-option *ngFor="let category of categories" [value]="category" >
                                  {{category}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <ng-container *ngFor="let validation of validation_messages.category">
                              <mat-error *ngIf="exampleForm.get('category').hasError(validation.type) && (exampleForm.get('category').dirty || exampleForm.get('category').touched)">{{validation.message}}</mat-error>
                            </ng-container>
                        </div>
                          
                        <!-- <div class="form-group">
                            
                                <div class="btn btn-outline-success pointer"><label for="image">Select Image</label></div> 
                                <input type="file" accept="image/*" name="image" id='image' class="hidden" (change)=upload($event)>
                            
                        </div> -->
                    </div>
                </div>
    
    
              <div class="row">
                <div class="col-md-4 mb-3">
                  <button mat-raised-button color="primary" type="submit" [disabled]="!exampleForm.valid">Create Plan</button>
                </div>
              </div>
    
            </form>
        </div>
        <!-- <div class="col col-7" *ngIf='imgUploaded'>
             <img id="planimg" [src]="url">
        </div> -->
    </div>
</div>